import React from "react";
import { Outlet, Link, NavLink, useNavigate, Navigate } from "react-router-dom";
import { useCustomerAuth } from "../../contexts/CustomerAuthContext";
import { LayoutDashboard, Target, MessageCircle, HelpCircle, BookOpen, UserCircle, LogOut, Crosshair, Loader2 } from "lucide-react";

export function CustomerProtectedRoute({ children }) {
  const { customer, loading } = useCustomerAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500"><Loader2 className="w-5 h-5 animate-spin" /></div>;
  if (!customer) return <Navigate to="/customer/login" replace />;
  return children;
}

export default function CustomerLayout() {
  const { customer, logout } = useCustomerAuth();
  const nav = useNavigate();
  const links = [
    { to: "/app/dashboard", label: "Dashboard",  icon: LayoutDashboard },
    { to: "/app/pursuits",  label: "Pursuits",   icon: Target },
    { to: "/app/copilot",   label: "AI Copilot", icon: MessageCircle },
    { to: "/app/learning",  label: "Learning",   icon: BookOpen },
    { to: "/app/account",   label: "Account",    icon: UserCircle },
    { to: "/app/help",      label: "Help",       icon: HelpCircle },
  ];

  return (
    <div className="min-h-screen flex bg-[var(--bg-primary)]">
      <aside className="w-56 border-r border-[var(--border-soft)] bg-[var(--bg-secondary)] flex flex-col">
        <Link to="/app/dashboard" className="flex items-center gap-2.5 px-4 py-4 border-b border-[var(--border-soft)]">
          <div className="w-7 h-7 border border-sky-500/60 flex items-center justify-center bg-sky-500/5"><Crosshair className="w-3.5 h-3.5 text-sky-400" strokeWidth={2.5} /></div>
          <div className="font-display font-black text-sm text-slate-100">GOVBID<span className="text-sky-400">IQ</span></div>
        </Link>
        <nav className="flex-1 p-2 space-y-1">
          {links.map((l) => {
            const Icon = l.icon;
            return (
              <NavLink key={l.to} to={l.to} data-testid={`cust-nav-${l.label.toLowerCase().replace(/\s/g,'-')}`}
                className={({isActive}) => `flex items-center gap-2 px-3 py-2 font-mono text-[11px] tracking-widest uppercase ${isActive ? "bg-sky-500/10 text-sky-300 border-l-2 border-sky-500" : "text-slate-400 hover:text-slate-100"}`}>
                <Icon className="w-3.5 h-3.5" /> {l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="p-3 border-t border-[var(--border-soft)] text-[10px] font-mono">
          <div className="text-slate-500 truncate mb-2">{customer?.email}</div>
          <button onClick={async () => { await logout(); nav("/customer/login"); }} data-testid="cust-logout" className="inline-flex items-center gap-1.5 text-rose-300 hover:text-rose-200 tracking-widest uppercase">
            <LogOut className="w-3 h-3" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 p-6 max-w-[1300px]"><Outlet /></main>
    </div>
  );
}
